import React from "react"
import paymentImage from "../../../public/static/images/svg/fetcher/payment.svg"

const PaymentLogo = () => {
  return (
    <img
      src={paymentImage}
      alt="Make a secure payment for your NYC parking ticket"
    />
  )
}

export default PaymentLogo
